module.exports = __webpack_public_path__ + "static/media/header-logo.61754f3c.png";